import api from "../../../utils/api";

export const login = async (credentials) => {
  const res = await api.post("/auth/login", credentials, {
    headers: credentials.subdomain ? { "X-Tenant": credentials.subdomain } : {},
  });
  return res.data;
};

export const signup = async (userInfo) => {
  const res = await api.post("/auth/signup", userInfo);
  return res.data;
};

export const logout = async () => {
  const res = await api.post("/auth/logout");
  return res.data;
};

export const refreshAccessToken = async () => {
  // Refresh token is sent automatically via HTTP-only cookie with withCredentials: true
  const res = await api.post("/auth/refresh", {});
  return res.data;
};
